import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui'
import { useToast } from '@/hooks'
import { type Statement, useProjectMutations } from '@/modules/projects'
import { useDialogActions, useDialogData, useDialogIsOpen } from '@/stores'

const dialogId = 'delete-statements'

export const DeleteStatementsDialog = () => {
  const { successToast, errorToast } = useToast()
  const open = useDialogIsOpen(dialogId)
  const toDelete = (useDialogData() as Statement[] | undefined) || []
  const { closeDialog } = useDialogActions()
  const total = toDelete?.length || 0
  const statement = total === 1 ? toDelete[0] : null
  const label = statement ? 'Statement' : 'Statements'

  const { deleteStatements } = useProjectMutations()
  const handleSubmit = () => {
    deleteStatements(toDelete)
      .then(() => successToast(`${label} deleted successfully`))
      .catch((error) => errorToast('Failed to delete statements', error))
    closeDialog(true)
  }

  return (
    <Dialog open={open} onOpenChange={(open) => !open && closeDialog()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Delete {label}?</DialogTitle>
          <DialogDescription>
            This will permanently delete{' '}
            {statement ? `"${statement.fileName}"` : `${total} statements`}.
            This action cannot be undone.
          </DialogDescription>
        </DialogHeader>
        <div className="flex justify-end gap-2 pt-4">
          <Button theme="outline" onClick={() => closeDialog()}>
            Cancel
          </Button>
          <Button onClick={handleSubmit} theme="danger">
            Delete {label}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  )
}

DeleteStatementsDialog.id = dialogId
